<template>
  <div class="wrapper">
    <div class="page-header page-header-small">
      <parallax class="page-header-image" style="background-image: url('img/salud/06.jpg')"></parallax>
      <div class="content-center">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <h1 class="title">OSAPM</h1>
            <h4>{{ constants.appSubtitle }}</h4>
            <!-- <h5>OSAPM
                RNOS: 1-1820-0 | RNEMP: 1417 Links | Teléfonos útiles | Contacto
                SSSALUD 0800-222-72583
                SSSalud - Organismo de control | www.sssalud.gov.ar
                Avellaneda 2144 (C1406FYT)
                Ciudad Autónoma de Buenos Aires
                (54-11) 4633-7878
            </h5>-->
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <!--     *********   ACCESOS   {{ constants.appTitle }}  *********      -->
      <div class="accesos-ususarios text-center">
        <div class="features-3">
          <div class="container">
            <div class="row">
              <div class="col-md-6">
                <div class="info info-hover">
                  <a href="https://osapm.zaiq.co/#/afiliado/cartilla">
                    <div class="icon icon-primary icon-circle">
                      <i class="now-ui-icons design_bullet-list-67"></i>
                    </div>
                    <h4 class="info-title">Cartilla Prestadores</h4>
                  </a>
                  <p class="description">Acceda a los prestadores que contamos para usted</p>
                </div>
              </div>
              <!-- <div class="col-md-4">
                <div class="info info-hover">
                  <div class="icon icon-success icon-circle">
                    <i class="now-ui-icons users_single-02"></i>
                  </div>
                  <h4 class="info-title">Acceso Afiliados</h4>
                  <p class="description">Ingrese al sistema de consultas privadas del Afiliado.</p>
                </div>
              </div>-->
              <div class="col-md-6">
                <div class="info info-hover">
                  <a href="#/login">
                    <div class="icon icon-info icon-circle">
                      <i class="now-ui-icons users_circle-08"></i>
                    </div>
                    <h4 class="info-title">Acceso a Afiliados y Prestadores</h4>
                  </a>
                  <p
                    class="description"
                  >Ingrese al sistema de consultas privadas del Afiliado / Prestador.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--     *********    END ACCESOS     *********      -->
      <div class="separator-line separator-primary"></div>

      <!--     *********    END NOTICIAS     *********      -->
      <div class="noticias">
        <h3 class="title text-center">Ultimas Novedades</h3>
        <br>
        <div class="container">
          <div class="row">
            <div class="col-md-4">
              <card type="blog" plain>
                <img slot="image" class="img rounded img-raised" src="img/salud/04.jpg">
                <h6 class="category text-info">Salud</h6>
                <h4 class="card-title">
                  <a href="#pablo">Noticia Numero 1</a>
                </h4>
                <p class="card-description">
                  Resumen de la Noticia numero 1.
                  <a href="#pablo">Ver mas...</a>
                </p>
              </card>
            </div>
            <div class="col-md-4">
              <card type="blog" plain>
                <img slot="image" class="img rounded img-raised" src="img/salud/03.jpg">
                <h6 class="category text-success">Salud</h6>
                <h4 class="card-title">
                  <a href="#pablo">Noticia numero 2</a>
                </h4>
                <p class="card-description">
                  Resumen de la noticia numero 2
                  <a href="#pablo">Ver mas...</a>
                </p>
                <!-- <div class="author">
                            <img v-lazy="'img/michael.jpg'" alt="..." class="avatar img-raised">
                            <span>John Black</span>
                </div>-->
              </card>
            </div>
            <div class="col-md-4">
              <div class="card card-plain card-blog">
                <div class="card-image">
                  <a href="#pablo">
                    <img class="img rounded img-raised" src="img/salud/02.jpg">
                  </a>
                </div>
                <div class="card-body">
                  <h6 class="category text-danger">
                    <i class="now-ui-icons media-2_sound-wave"></i> Salud
                  </h6>
                  <h4 class="card-title">
                    <a href="#pablo">Noticia numero 3</a>
                  </h4>
                  <p class="card-description">
                    Resumen de la noticia numero 3
                    <a href="#pablo">Ver mas...</a>
                    <!-- <div class="author">
                                <img v-lazy="'img/james.jpg'" alt="..." class="avatar img-raised">
                                <span>James Newman</span>
                    </div>-->
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5 ml-auto mr-auto">
              <div class="submit text-center">
                <a href="#/noticias" class="btn btn-primary btn-round mt-4 btn-lg" round>Ver Todas</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--     *********    END NOTICIAS     *********      -->
      <!--     *********    PLANES     *********      -->
      <div class="planes">
        <div class="pricing-4" style="background-image: url('img/bg19.jpg')">
          <div class="container">
            <div class="row">
              <div class="col-md-6 ml-auto mr-auto text-center">
                <h2 class="title text-white">Nuestros Planes</h2>
                <h4
                  class="description text-white"
                >Los planes disponibles por OSAPM estan detallados a continuacion con sus respectivas especificaciones.</h4>
                <div class="section-space"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <card type="pricing" white>
                  <h6 class="category">Plan 5000</h6>
                  <div class="icon icon-info">
                    <i class="now-ui-icons business_briefcase-24"></i>
                  </div>
                  <h3 class="card-title">
                    <small>Beneficios</small>
                  </h3>
                  <ul>
                    <li>Servicio 1</li>
                    <li>Servicio 2</li>
                    <li>Servicio 3</li>
                  </ul>
                  <n-button type="info" round>Mas informacion del Plan</n-button>
                </card>
              </div>
              <div class="col-md-4">
                <card type="pricing" white>
                  <h6 class="category">Plan 5000 APM</h6>
                  <div class="icon icon-success">
                    <i class="now-ui-icons business_briefcase-24"></i>
                  </div>
                  <h3 class="card-title">
                    <small>Beneficios</small>
                  </h3>
                  <ul>
                    <li>Servicio 1</li>
                    <li>Servicio 2</li>
                    <li>Servicio 3</li>
                  </ul>
                  <n-button type="success" round>Mas informacion del Plan</n-button>
                </card>
              </div>
              <div class="col-md-4">
                <card type="pricing" white>
                  <h6 class="category">Profesional</h6>
                  <div class="icon icon-warning">
                    <i class="now-ui-icons business_briefcase-24"></i>
                  </div>
                  <h3 class="card-title">
                    <small>Beneficios</small>
                  </h3>
                  <ul>
                    <li>Servicio 1</li>
                    <li>Servicio 2</li>
                    <li>Servicio 3</li>
                  </ul>
                  <n-button type="warning" round>Mas informacion del Plan</n-button>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--     *********    END PLANES     *********      -->
      <!--     *********    CONTACT WORK     *********      -->
      <div class="about-contact">
        <div class="container">
          <div class="row">
            <div class="col-md-8 mr-auto ml-auto">
              <h2 class="text-center title">¿Quieres trabajar con Nosotros?</h2>
              <h4
                class="text-center description"
              >Envianos tu informacion para poder contactnarnos con vos.</h4>
              <form class="contact-form">
                <div class="row">
                  <div class="col-md-4">
                    <label>Nombre</label>
                    <fg-input
                      addon-left-icon="now-ui-icons users_circle-08"
                      v-model="form.firstName"
                      placeholder="Nombre ..."
                    ></fg-input>
                  </div>
                  <div class="col-md-4">
                    <label>Email</label>
                    <fg-input
                      addon-left-icon="now-ui-icons ui-1_email-85"
                      v-model="form.email"
                      placeholder="Email..."
                    ></fg-input>
                  </div>
                  <div class="col-md-4">
                    <label>Nivel de Estudio</label>
                    <fg-input>
                      <el-select class="select-default" v-model="form.speciality">
                        <el-option class="select-default" value="1" label="Primario Finalizado"></el-option>
                        <el-option class="select-default" value="2" label="Secundario Finalizado"></el-option>
                        <el-option class="select-default" value="3" label="Terciario Finalizado"></el-option>
                        <el-option class="select-default" value="4" label="Terciario en Curso"></el-option>
                        <el-option class="select-default" value="5" label="Universitario en Curso"></el-option>
                        <el-option
                          class="select-default"
                          value="6"
                          label="Universitario Finalizado"
                        ></el-option>
                      </el-select>
                    </fg-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 ml-auto mr-auto text-center">
                    <button class="btn btn-primary btn-round mt-4 btn-lg">Enviar</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!--     *********    END CONTACT WORK     *********      -->
      <div class="separator-line separator-primary"></div>

      <!--     *********    SIMPLE SOCIAL LINE     *********      -->
      <div class="social-line social-line-white text-center">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-12">
              <h4 class="title">Gracias por su confianza</h4>
            </div>
            <n-button round class="btn-twitter">
              <i class="fab fa-twitter"></i> Twitter
            </n-button>
            <n-button round class="btn-facebook">
              <i class="fab fa-facebook-square"></i> Facebook
            </n-button>
            <n-button round class="btn-google">
              <i class="fab fa-google-plus"></i> Google
            </n-button>
            <n-button round class="btn-default">
              <i class="fab fa-instagram"></i> Instagram
            </n-button>
          </div>
        </div>
      </div>
      <!--     *********   SIMPLE SOCIAL LINE     *********      -->
    </div>
  </div>
</template>
<script>
import {
  Card,
  Button,
  Badge,
  InfoSection,
  FormGroupInput,
  Checkbox
} from "@/components";
import { Select, Option } from "element-ui";

export default {
  name: "home",
  bodyClass: "home",
  components: {
    Card,
    InfoSection,
    Badge,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [FormGroupInput.name]: FormGroupInput,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      form: {
        firstName: "",
        email: "",
        speciality: ""
      }
    };
  }
};
</script>
<style scoped>
.section {
  padding: 0px 0;
  position: relative;
  background: #ffffff;
}
.about-us .about-description {
  padding: 0px 0px 0px 0px;
}
</style>
